import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=2c6ca920&scoped=true"
import script from "./WarningModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./WarningModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WarningModal.vue?vue&type=style&index=0&id=2c6ca920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ca920",
  null
  
)

export default component.exports